import { z } from "zod";
import { PetPrefectureSchema } from "#core/pets/PetStoreLocation.js";
export const MunicipalityShapeSchema = z.object({
    name: z.string().min(1),
    path: z.string().min(1),
});
/** 都道府県の市区町村境界を、width×height の座標系に投影した SVG パスで持つ */
export const PrefectureMapSchema = z.object({
    prefecture: PetPrefectureSchema,
    width: z.number().positive(),
    height: z.number().positive(),
    municipalities: z.array(MunicipalityShapeSchema),
});
export const PrefectureMapsSchema = z.array(PrefectureMapSchema);
